import { jsx as r, jsxs as g, Fragment as tt } from "react/jsx-runtime";
import { c as ot } from "react/compiler-runtime";
import w from "react";
import K from "@mui/material/Button";
import { Typography as U } from "@mui/material";
import it from "./index.js";
import "../../../chunks/Map.js";
import "../../../styles/theme.js";
import "@mui/icons-material/InfoOutlined";
import "@mui/icons-material/ArrowDropDown";
import "@mui/icons-material/ArrowDropUp";
import "@mui/icons-material/ArrowLeft";
import "@mui/icons-material/ArrowRight";
import "@mui/icons-material";
import "highcharts-react-official";
import "highcharts";
import "moment-timezone";
import "highcharts/highcharts";
import "../../molecules/Widgets/WidgetTimelineGraph/WidgetTimelineGraph.styles.js";
import "react-dom/client";
import "react-dom/server";
import "@mui/icons-material/Warning";
import "reactflow";
import "reactflow/dist/style.css";
import "dagre";
import "../../molecules/NetworkMap/NetworkMapUtils.js";
import "@mui/icons-material/FilterAlt";
import '../../../assets/map.css';import '../../../assets/FilterWrapper.css';/* empty css                            */
import "@mui/material/Menu";
import "@mui/material/FormControl";
import "@mui/material/ListSubheader";
import "lodash";
import "@mui/icons-material/KeyboardArrowDown";
import "@mui/icons-material/Close";
import "@mui/icons-material/Search";
import "../../atoms/Box/Box.js";
import "../../atoms/Grid/Grid.js";
import "../../atoms/Typography/Typography.js";
import "@mui/material/styles";
import "@mui/material/TextField";
import "@mui/material/Fab";
import "@mui/material/TextareaAutosize";
import "@mui/material/InputLabel";
import "@mui/material/CardContent";
import "@mui/material/CardHeader";
import "@mui/material/Collapse";
import "@mui/material/ClickAwayListener";
import "@mui/material/Grow";
import "@mui/material/Fade";
import "@mui/material/Popper";
import "@mui/material/MenuList";
import "@mui/material/Breadcrumbs";
import "@mui/material/Dialog";
import "@mui/material/Modal";
import "@mui/material/FormGroup";
import "@mui/material/Accordion";
import "@mui/material/AccordionSummary";
import "@mui/material/AccordionDetails";
import "@mui/material/Select";
import "@mui/material/Autocomplete";
import "@mui/material/InputAdornment";
import "@mui/material/AlertTitle";
import "@mui/material/ListItemText";
import "@mui/material/List";
import "@mui/material/ListItem";
import "@mui/material/ListItemButton";
import "@mui/material/ListItemAvatar";
import "@mui/material/Backdrop";
import "@mui/material/ListItemIcon";
import "@mui/material/Popover";
import "@mui/material/Drawer";
import "@mui/material/CardMedia";
import "@mui/material/Snackbar";
import "@mui/material/TablePagination";
import "@mui/material/colors";
import "@mui/material/useMediaQuery";
import "@mui/material/OutlinedInput";
import "@mui/icons-material/CheckCircle";
import "@mui/icons-material/RestartAlt";
import "@mui/icons-material/Info";
import "@mui/icons-material/Add";
import "@mui/icons-material/Build";
import "../../../chunks/ChatbotContext.js";
import "react-markdown";
import "remark-gfm";
import "rehype-raw";
import "rehype-sanitize";
import "@mui/icons-material/EventOutlined";
import "@mui/icons-material/KeyboardArrowDownOutlined";
import "@mui/icons-material/CloseRounded";
import "../DateTimeSelector/DateTimeSelectorMenu.js";
import "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import "@mui/icons-material/Visibility";
import "@mui/icons-material/VisibilityOff";
import "@mui/icons-material/ArrowForward";
import "../RadarGraph/RadarGraph.js";
import "./GMapStatic.js";
import "./hooks.js";
import "@mui/icons-material/Clear";
import "../../../chunks/TableContext.js";
import "@tanstack/react-table";
import "@tanstack/react-virtual";
import "@mui/icons-material/FilterAltOff";
import "react-window";
import "../Table/TimeRangeFilter.js";
import "@mui/icons-material/KeyboardDoubleArrowLeft";
import "@mui/icons-material/KeyboardDoubleArrowRight";
import "@mui/icons-material/KeyboardArrowLeft";
import "@mui/icons-material/KeyboardArrowRight";
import "@mui/icons-material/ViewWeek";
import "@mui/icons-material/DragIndicator";
import "../ScoreGauge/ScoreGauge.js";
import "../SunburstGraph/SunburstGraph.js";
import "@mui/icons-material/Menu";
import "../../../fetch/fetchConfig.js";
import "immer";
import "../../atoms/FormControl/FormControl.js";
import "../../atoms/FormControlLabel/FormControlLabel.js";
import "@react-google-maps/api";
import "../../../chunks/index.esm.js";
/* empty css                   */
import "../../atoms/Paper/Paper.js";
import "../../atoms/Radio/Radio.js";
import "../../atoms/RadioGroup/RadioGroup.js";
import "../../atoms/Menu/Menu.js";
import "../../atoms/MenuItem/MenuItem.js";
import "../../atoms/Table/Table.js";
import "../../atoms/TableBody/TableBody.js";
import "../../atoms/TableHead/TableHead.js";
import "../../atoms/TableRow/TableRow.js";
import "../../atoms/TableCell/TableCell.js";
import "../../atoms/ToggleButton/ToggleButton.js";
import "../../atoms/ToggleButtonGroup/ToggleButtonGroup.js";
import "@mui/icons-material/ExpandMore";
import "../../atoms/Stepper/Stepper.js";
import "../../atoms/Step/Step.js";
import "../../atoms/StepLabel/StepLabel.js";
import "../../atoms/Link/Link.js";
import "../../atoms/LoadingButton/LoadingButton.js";
import "../../atoms/LinearProgress/LinearProgress.js";
import "../../atoms/Stack/Stack.js";
import "../../atoms/Card/Card.js";
import "../../atoms/CardActions/CardActions.js";
import "../../atoms/FormHelperText/FormHelperText.js";
import "../../atoms/AccordionDetails/AccordionDetails.js";
import "../../atoms/TableContainer/TableContainer.js";
import { DialogTitle as rt, DialogActions as et, DialogContent as mt, DialogBox as pt } from "../../atoms/Dialog/Dialog.js";
const z = {
  // name: "20972 Saratoga Hills Rd, Saratoga, CA 95070, USA",
  lat: 37.26534961208239,
  lng: -122.04076419999998
}, V = 1e-5, lt = (e, t) => e.lat === void 0 || e.lng === void 0 || Math.abs(e.lat - t.lat) > V || Math.abs(e.lng - t.lng) > V, Ui = (e) => {
  const t = ot(46), {
    label: E,
    title: F,
    getLocationDetails: O,
    selectedLocation: _,
    apiKey: T,
    requireManualSelection: P
  } = e, m = P === void 0 ? !1 : P, [j, $] = w.useState(!1), [o, J] = w.useState(_), [X, Q] = w.useState(!1), S = w.useRef(null);
  let v;
  t[0] !== m || t[1] !== _ ? (v = () => {
    J(_), Q(!m), S.current = null, $(!0);
  }, t[0] = m, t[1] = _, t[2] = v) : v = t[2];
  const q = v;
  let y;
  t[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = () => {
    $(!1), S.current = null;
  }, t[3] = y) : y = t[3];
  const C = y;
  let b;
  t[4] !== m ? (b = (i) => {
    const Z = {
      lat: i.center.lat,
      lng: i.center.lng,
      address: i.address,
      zoom: i.zoom
    };
    if (J(Z), !!m) {
      if (!S.current) {
        S.current = {
          lat: i.center.lat,
          lng: i.center.lng
        };
        return;
      }
      lt(S.current, i.center) && Q(!0);
    }
  }, t[4] = m, t[5] = b) : b = t[5];
  const A = b, Y = X && o?.lat !== void 0 && o?.lng !== void 0;
  let M;
  t[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (M = {
    height: 25
  }, t[6] = M) : M = t[6];
  let p;
  t[7] !== q || t[8] !== E ? (p = /* @__PURE__ */ r(K, { style: M, variant: "outlined", color: "primary", onClick: q, children: E }), t[7] = q, t[8] = E, t[9] = p) : p = t[9];
  let l;
  t[10] !== F ? (l = /* @__PURE__ */ r(rt, { id: "customized-dialog-title", onClose: C, children: F }), t[10] = F, t[11] = l) : l = t[11];
  const B = o?.lat || z.lat, N = o?.lng || z.lng;
  let n;
  t[12] !== B || t[13] !== N ? (n = {
    lat: B,
    lng: N
  }, t[12] = B, t[13] = N, t[14] = n) : n = t[14];
  let a;
  t[15] !== T || t[16] !== A || t[17] !== n ? (a = /* @__PURE__ */ r(it, { width: "100%", height: "400px", apiKey: T, center: n, getMapData: A, showCurrentLocation: !0, showCenterMarker: !0 }), t[15] = T, t[16] = A, t[17] = n, t[18] = a) : a = t[18];
  let D;
  t[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = {}, t[19] = D) : D = t[19];
  const W = o?.lat || z.lat, G = o?.lng || z.lng;
  let c;
  t[20] !== W || t[21] !== G ? (c = /* @__PURE__ */ g(U, { variant: "caption", sx: D, children: [
    "Latitude: ",
    W,
    ", Longitude: ",
    G
  ] }), t[20] = W, t[21] = G, t[22] = c) : c = t[22];
  let L;
  t[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (L = /* @__PURE__ */ r("br", {}), t[23] = L) : L = t[23];
  let x;
  t[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (x = {}, t[24] = x) : x = t[24];
  const H = o?.address;
  let s;
  t[25] !== H ? (s = /* @__PURE__ */ g(U, { variant: "caption", sx: x, children: [
    "Address : ",
    /* @__PURE__ */ r("i", { children: H })
  ] }), t[25] = H, t[26] = s) : s = t[26];
  let k;
  t[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = /* @__PURE__ */ r(K, { autoFocus: !0, onClick: C, color: "inherit", variant: "outlined", children: "Close" }), t[27] = k) : k = t[27];
  const I = !Y;
  let d;
  t[28] !== O || t[29] !== o ? (d = () => {
    !o?.lat || !o?.lng || (O(o), C());
  }, t[28] = O, t[29] = o, t[30] = d) : d = t[30];
  let f;
  t[31] !== I || t[32] !== d ? (f = /* @__PURE__ */ g(et, { children: [
    k,
    /* @__PURE__ */ r(K, { autoFocus: !0, variant: "contained", disabled: I, onClick: d, color: "primary", children: "Save" })
  ] }), t[31] = I, t[32] = d, t[33] = f) : f = t[33];
  let u;
  t[34] !== a || t[35] !== c || t[36] !== s || t[37] !== f ? (u = /* @__PURE__ */ g(mt, { dividers: !0, children: [
    a,
    c,
    L,
    s,
    f
  ] }), t[34] = a, t[35] = c, t[36] = s, t[37] = f, t[38] = u) : u = t[38];
  let h;
  t[39] !== j || t[40] !== u || t[41] !== l ? (h = /* @__PURE__ */ g(pt, { onClose: C, "aria-labelledby": "customized-dialog-title", open: j, fullWidth: !0, maxWidth: "md", children: [
    l,
    u
  ] }), t[39] = j, t[40] = u, t[41] = l, t[42] = h) : h = t[42];
  let R;
  return t[43] !== h || t[44] !== p ? (R = /* @__PURE__ */ g(tt, { children: [
    p,
    h
  ] }), t[43] = h, t[44] = p, t[45] = R) : R = t[45], R;
};
export {
  Ui as default
};
